/**
 * Defines the possible statuses of a snackbar message.
 * - Error. Represent an error event: user tried to submit a form with invalid data, network error, etc.
 */
export enum SnackbarStatus {
  Error = 'error'
}
